/**
 * Utility functions for date calculations regarding pin expiration
 */

// Configuration for expiration warnings
export const EXPIRY_WARNING_DAYS = 7;
export const MIN_OPACITY = 0.4;

/**
 * Calculate the number of days until a date expires
 * @param {string|Date} expiresAt - The expiration date
 * @returns {number|null} Number of days left (can be fractional), or null if invalid date
 */
export const getDaysUntilExpiry = (expiresAt) => {
  if (!expiresAt) return null;
  
  const now = new Date();
  const expires = new Date(expiresAt);
  
  // Check if date is valid
  if (isNaN(expires.getTime())) return null;
  
  // Calculate difference in milliseconds and convert to days
  const diffMs = expires - now;
  const daysLeft = diffMs / (1000 * 60 * 60 * 24);
  
  return daysLeft;
};

/**
 * Get the status of a pin regarding its expiration
 * @param {string|Date} expiresAt - The expiration date
 * @returns {Object} Status object with { isExpiring, opacity, daysLeft, label }
 */
export const getExpiryStatus = (expiresAt) => {
  // TEMPORARILY DISABLED: expiration warnings + fading.
  // const daysLeft = getDaysUntilExpiry(expiresAt);
  // ... previous warning/fade logic intentionally disabled.
  return {
    isExpiring: false,
    opacity: 1,
    daysLeft: null,
    exactDaysLeft: null,
    label: ''
  };
};

/**
 * Format a date as a relative "time ago" string
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted string (e.g., "Today", "Yesterday", "5d ago")
 */
export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  
  const now = new Date();
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) return '';
  
  // Calculate difference in days
  const diffTime = now - date;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  // Handle future dates (if user manually edits DB to future)
  if (diffDays < 0) return 'Just now';
  
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  return `${diffDays}d ago`;
};
